import React from 'react';

const BathroomPlaceholder = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={108} height={55} fill="none" {...props}>
    <path stroke="#959595" strokeLinecap="round" strokeWidth={2} d="m44.253 48.264 2.25 4.5M21.516 48.516 19 52.873" />
    <path fill="#F3F3F3" stroke="#AAA" strokeWidth={2} d="M63 2h25v29H63V2Z" />
    <path fill="#959595" stroke="#B3B3B3" strokeWidth={2} d="M63 30h23v1H63v-1Z" opacity={0.52} />
    <path fill="#959595" stroke="#E4E4E4" strokeWidth={2} d="M63 2h23v1H63V2Z" opacity={0.48} />
    <path
      stroke="#959595"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="M59 32h33M62.767 1h25.466v31H62.767V1Z"
    />
    <path
      stroke="#C4C4C4"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.6}
      d="m67 15.311 6.52-6.98m1.604 4.96L81 7M68.856 20l4.094-4.382"
    />
    <circle cx={31.5} cy={4.5} r={1.5} fill="#D9D9D9" stroke="#959595" strokeWidth={2} />
    <circle cx={35.5} cy={15.5} r={1.5} fill="#D9D9D9" stroke="#959595" strokeWidth={2} />
    <circle cx={38.5} cy={8.5} r={1.5} fill="#D9D9D9" stroke="#959595" strokeWidth={2} />
    <path
      stroke="#959595"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M47.106 23.165c1.295 1.916 2.54 2.465 3.394 2.121-.23.778-1.885 1.856-2.939 2.477a.893.893 0 0 0-.27 1.298c.578.772 1.378 1.863 1.512 2.165 2.99 5.426-3.598 7.487-6.788 7.212-9.394-.81-9.06-8.144-7.636-11.03 3.416 5.936 8.689 2.509 8.485 1.272-.204-1.236-1.61-.99-2.122-2.97-.854-3.916 4.508-5.77 6.364-2.545Z"
    />
    <path
      stroke="#959595"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M44.136 32.923c-1.06 1.484-4.242 2.97-6.788.848"
    />
    <path
      fill="#959595"
      d="M44.985 25.71a.849.849 0 1 1 0-1.697.849.849 0 0 1 0 1.697ZM19.873 4c3.797 0 6.888 3.36 6.888 7.49 0 .815 1.48 1.955 3.177 2.263.581 0 1.062.518 1.062 1.155 0 .633-.476 1.155-1.062 1.155h-8.272c-.582 0-1.062-.517-1.062-1.155 0-.632.476-1.155 1.062-1.155 1.692-.313 3.177-1.448 3.177-2.263 0-2.974-2.225-5.394-4.96-5.394s-4.96 2.42-4.96 5.394V38H13V11.485C12.99 7.355 16.076 4 19.873 4Z"
    />
    <path
      stroke="#959595"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.5}
      d="M30.096 38.254a2.376 2.376 0 0 0-1.053-4.517 3.944 3.944 0 0 0-7.811.29 2.369 2.369 0 0 0-2.797 3.765"
    />
    <mask id="a" fill="#fff">
      <path d="M51 36c.552 0 1.004.448.962.999a13.656 13.656 0 0 1-1.446 5.124c-.98 1.941-2.417 3.705-4.227 5.19-1.811 1.486-3.96 2.665-6.327 3.47A23.255 23.255 0 0 1 32.5 52c-2.56 0-5.096-.414-7.462-1.218-2.366-.804-4.516-1.983-6.327-3.468-1.81-1.486-3.247-3.25-4.227-5.191a13.656 13.656 0 0 1-1.446-5.124c-.042-.55.41-.999.962-.999h37Z" />
    </mask>
    <path
      fill="#F3F3F3"
      stroke="#959595"
      strokeWidth={4}
      d="M51 36c.552 0 1.004.448.962.999a13.656 13.656 0 0 1-1.446 5.124c-.98 1.941-2.417 3.705-4.227 5.19-1.811 1.486-3.96 2.665-6.327 3.47A23.255 23.255 0 0 1 32.5 52c-2.56 0-5.096-.414-7.462-1.218-2.366-.804-4.516-1.983-6.327-3.468-1.81-1.486-3.247-3.25-4.227-5.191a13.656 13.656 0 0 1-1.446-5.124c-.042-.55.41-.999.962-.999h37Z"
      mask="url(#a)"
    />
    <mask id="b" fill="#fff">
      <path d="M47 39c.552 0 1.008.45.923.996-.15.972-.522 1.925-1.103 2.83-.779 1.214-1.92 2.316-3.36 3.245-1.44.929-3.148 1.665-5.028 2.168-1.881.502-3.897.761-5.932.761-2.035 0-4.051-.259-5.932-.761-1.88-.503-3.589-1.24-5.028-2.168-1.44-.928-2.581-2.03-3.36-3.244-.581-.905-.952-1.86-1.103-2.831-.085-.546.37-.996.923-.996h29Z" />
    </mask>
    <path
      fill="#D9D9D9"
      stroke="#959595"
      strokeWidth={2}
      d="M47 39c.552 0 1.008.45.923.996-.15.972-.522 1.925-1.103 2.83-.779 1.214-1.92 2.316-3.36 3.245-1.44.929-3.148 1.665-5.028 2.168-1.881.502-3.897.761-5.932.761-2.035 0-4.051-.259-5.932-.761-1.88-.503-3.589-1.24-5.028-2.168-1.44-.928-2.581-2.03-3.36-3.244-.581-.905-.952-1.86-1.103-2.831-.085-.546.37-.996.923-.996h29Z"
      mask="url(#b)"
    />
    <path stroke="#959595" strokeLinecap="round" strokeWidth={2} d="M11 37h43" />
    <path
      stroke="#959595"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="M1 54h106"
    />
  </svg>
);

export default BathroomPlaceholder;
